import scss from "../AnalitycCard.module.scss";

const AnanlyticBlock = ({ title = "", value = "", icon: Icon, tone = "stone" }) => {
    return (
        <article className={`${scss.analyticCard} ${scss[tone]}`}>
            <div className={scss.analyticCardIcon} aria-hidden="true">
                <Icon fontSize="small" />
            </div>
            <h6 className={scss.analyticCardTitle}>{title}</h6>
            <p className={scss.analyticCardValue}>{value}</p>
        </article>
    );
};

export default AnanlyticBlock;
